import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { createReview, getProduct, getRelatedProducts } from "../../actions/productActions";
import Loader from "../layouts/Loader";
import MetaData from "../layouts/MetaData";
import { Modal } from 'react-bootstrap';
import { addCartItemToCart } from "../../actions/cartActions";
import { addCartItem, } from "../../slices/cartSlice";
import { clearError, clearProduct, clearReviewSubmitted } from "../../slices/singleProductSlice";
import { toast } from "react-toastify";
import ProductReview from "./ProductReview";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import './ProductDetail.css'
import {
    FontAwesomeIcon
} from "@fortawesome/react-fontawesome";
import {
    faStar
} from "@fortawesome/free-solid-svg-icons";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import Product from "./Product";
import { logEvent } from "../../actions/analyticsActions";
import Nav from "../layouts/nav";
export default function ProductDetail() {
    const { loading, product = {}, isReviewSubmitted, error } = useSelector((state) => state.productState);
    const { relatedProducts, loading: relatedLoading } = useSelector((state) => state.relatedProductsState);
    const { user } = useSelector((state) => state.authState);
    const dispatch = useDispatch();
    const { id } = useParams();
    const [quantity, setQuantity] = useState(1);
    const [mainMedia, setMainMedia] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [mainImage, setMainImage] = useState('');    // Set the first image as the default main image.
    // Add this state
    // console.log(user)
    const [selectedVariant, setSelectedVariant] = useState(null);
    useEffect(() => {
        if (product.images && product.images.length > 0) {
            setMainImage(product.images[0].image); // Set the first image as the default main image
        }
    }, [product.images]);
    // Related Product
    useEffect(() => {

        // Fetch related products when the main product is loaded
        if (product.maincategory) {
            dispatch(getRelatedProducts(product.maincategory));
        }
    }, [dispatch, product.maincategory]);
    const handleThumbnailClick = (image) => {
        setMainImage(image);
    };



    useEffect(() => {
        if (product.images && product.images.length > 0) {
            setMainMedia(product.images[0]);
        }
    }, [product.images]);

    const getAvailableStock = () => {
        return selectedVariant ? selectedVariant.stock : product.stock;
    };

    const increaseQty = () => {
        const availableStock = getAvailableStock();
        if (availableStock === 0 || quantity >= availableStock) return;
        setQuantity((prevQuantity) => prevQuantity + 1);
    };

    const decreaseQty = () => {
        if (quantity === 1) return;
        setQuantity((prevQuantity) => prevQuantity - 1);
    };



    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [rating, setRating] = useState(1);
    const [comment, setComment] = useState("");
    const [reviewError, setError] = useState("");

    const reviewHandler = () => {
        if (!rating) {
            setError("Please select a rating.");
            return;
        }

        if (!comment || comment.trim().length < 10) {
            setError("Review must be at least 10 characters.");
            return;
        }

        setError(""); // Clear error if validation passes

        const formData = new FormData();
        formData.append("rating", rating);
        formData.append("comment", comment);
        formData.append("productId", id);

        dispatch(createReview(formData));
    };


    const handleAddToCart = () => {

        // Login check
        if (!user) {
          toast.error("Please login to add to cart");
          return;
        }

        if (quantity > (selectedVariant ? selectedVariant.stock : product.stock)) {
            toast.error("Quantity exceeds available stock");
            return;
        }

        const variantLabel = selectedVariant ? ` (${selectedVariant.variantName})` : "";
        const cartItem = {
            product: product._id,
            name: product.name + variantLabel, // ← append variant name if exists
            price: selectedVariant ? selectedVariant.offPrice : product.offPrice,
            image: selectedVariant ? selectedVariant.images[0] : product.images[0],
            stock: selectedVariant ? selectedVariant.stock : product.stock,
            quantity,
            tax: product.tax,
            shippingCostlol: product.shippingCostlol,
            shippingCostNorth: product.shippingCostNorth,
            shippingCostEast: product.shippingCostEast,
            shippingCostWest: product.shippingCostWest,
            shippingCostSouth: product.shippingCostSouth,
            shippingCostCentral: product.shippingCostCentral,
            shippingCostNe: product.shippingCostNe,
            additionalShippingCost: product.additionalShippingCost,
            createdBy: product.createdBy,
            variant: selectedVariant ? {
                _id: selectedVariant._id,
                variantType: selectedVariant.variantType,
                variantName: selectedVariant.variantName,
                price: selectedVariant.price,
                offPrice: selectedVariant.offPrice,
                stock: selectedVariant.stock,
                images: selectedVariant.images,
            } : null
        };

        if (user) {
            dispatch(addCartItemToCart(cartItem));
        } else {
            dispatch(addCartItem(cartItem));
            toast.success("Item added to cart successfully");
        }
    };

    useEffect(() => {
        if (product.variants && product.variants.length > 0) {
            setSelectedVariant(product.variants[0]);
            setMainImage(product.variants[0].images[0]); // Set the first image of the first variant as the default main image
        } else if (product.images && product.images.length > 0) {
            setMainImage(product.images[0]); // Set the first image as the default main image
        }
    }, [product.variants, product.images]);

    useEffect(() => {
        dispatch(getProduct(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (isReviewSubmitted) {
            handleClose();
            toast.success("Review submitted successfully");
            dispatch(clearReviewSubmitted());
        }
    }, [isReviewSubmitted, dispatch]);

    useEffect(() => {
        if (error) {
            toast.error("Thank you, Please login to rate the products");
            dispatch(clearError());
        }
    }, [error, dispatch]);

    useEffect(() => {
        return () => {
            dispatch(clearProduct());
        };
    }, []);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    useEffect(() => {
        const startTime = Date.now();
        return () => {
            const timeSpent = (Date.now() - startTime) / 1000;
            logEvent({ event: 'page_view', pageUrl: window.location.pathname, timeSpent });
        };
    }, []);

    useEffect(() => {
        setQuantity(1);
    }, [selectedVariant]);

    const formatPrice = (value) => {
      const price = Number(value || 0);

      return Number.isInteger(price)
        ? `${price}.00`
        : price.toFixed(2);
    };

    return (
      <>
        {loading ? (
          <Loader />
        ) : (
          <>
            <MetaData title={`${product.name} | GLOCRE Private Limited`} />
            <Nav />
            <div className="breadcrumbWrapper mb-2">
              <div className="container-fluid">
                <ul className="breadcrumb breadcrumb2 mb-0">
                  <li>
                    <Link to="/">Home</Link>
                  </li>

                  <li>
                    <Link to="/">Product</Link>
                  </li>

                  {product?.category && (
                    <li>
                      <Link to="/">{product.category}</Link>
                    </li>
                  )}

                  <li>{product?.name}</li>
                </ul>
              </div>
            </div>

            <section className="Product-page-glc container-fluid">
              {/* product details*/}
              <div className="product row">
                {/* Product Image Gallery */}
                <div className="column-xs-12 col-lg-4">
                  <div className="product-gallery">
                    {/* Carousel for Product Images */}
                    {/* <div className="main-image-container">
                                        <img
                                            className="prod-img-main-glc"
                                            src={mainImage}
                                            alt={product.name}
                                        />
                                    </div> */}

                    <div className="product-image-wrapper-newres" style={{fontSize:"14px"}}>
                      <img
                        src={mainImage}
                        alt={product.name}
                        className="product-image-newres img-fluid"
                      />
                    </div>

                    {/* Thumbnail List */}
                    <div className="prod-img-border">
                      <ul className="d-flex prod-img-down-glc-bg" style={{fontSize:"14px"}}>
                        {selectedVariant && selectedVariant.images.length > 0
                          ? selectedVariant.images.map((src, index) => (
                              <li
                                key={index}
                                className={`${mainImage === src ? 'active-thumbnail' : ''}`}
                                onClick={() => handleThumbnailClick(src)} // Set main image on click
                              >
                                <img
                                  src={src} // Use the correct image URL
                                  alt={`Thumbnail ${index + 1}`}
                                  className="prod-img-down-glc" // Optionally add styling class for thumbnail images
                                />
                              </li>
                            ))
                          : product.images &&
                            product.images.map((src, index) => (
                              <li
                                key={index}
                                className={`${mainImage === src ? 'active-thumbnail' : ''}`}
                                onClick={() => handleThumbnailClick(src)} // Set main image on click
                              >
                                <img
                                  src={src} // Use the correct image URL
                                  alt={`Thumbnail ${index + 1}`}
                                  className="prod-img-down-glc" // Optionally add styling class for thumbnail images
                                />
                              </li>
                            ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="column-xs-12 col-lg-5 description">
                  <h2 style={{ fontSize: '27px', textTransform:"capitalize" }}>{product.name}</h2>
                  <hr style={{ margin: 0 }} />
                  {/* Add this inside the return statement where you want to render the dropdown */}
                  {product.variants && product.variants.length > 0 && (
                    <div className="form-group">
                      <label htmlFor="variantSelect">
                        {product.variants[0].variantType}
                      </label>
                      <div className="custom-select-wrapper">
                        <select
                          id="variantSelect"
                          className="form-control custom-select"
                          value={selectedVariant ? selectedVariant._id : ''}
                          onChange={e => {
                            const variant = product.variants.find(
                              v => v._id === e.target.value
                            );
                            setSelectedVariant(variant);
                            setMainImage(variant.images[0]); // Update main image
                          }}
                        >
                          {product.variants.map(variant => (
                            <option key={variant._id} value={variant._id}>
                              {variant.variantName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}
                  <div className="description pt-2">
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      {product.brand && (
                        <tr>
                          <th style={{ fontSize: '17px' }}>Brand :&nbsp;</th>
                          <td style={{ fontSize: '17px' }}> {product.brand}</td>
                        </tr>
                      )}
                    </div>

                    <div>
                      <p
                        style={{
                          fontWeight: '500',
                          width: '100%',
                        }}
                        className="pt-2"
                      >
                        Features & Benefits:
                      </p>
                      <hr />

                      {/* Display Key Features Dynamically */}
                      <ul style={{ paddingLeft: '20px' }}>
                        {product.keyPoints && product.keyPoints.length > 0 ? (
                          product.keyPoints.map((feature, index) => (
                            <li
                              key={index}
                              style={{
                                fontSize: '16px',
                                margin: '0 0 10px',
                                color: '#8c8c8c',
                                listStyleType: 'disc',
                              }}
                            >
                              <p style={{ color: '#8c8c8c' }}></p>
                              {feature}
                            </li>
                          ))
                        ) : (
                          <li style={{ color: '#ffad63', fontStyle: 'italic' }}>
                            No key features available.
                          </li>
                        )}
                      </ul>
                    </div>

                    <div>{/* Accoridian */}</div>
                  </div>

                  {/* <button className="add-to-cart">Add To Cart</button> */}
                </div>
                <div
                  className="column-xs-12 col-lg-3 order-details-glc"
                  style={{
                    boxShadow: '10px 10px 40px #eeeeee',
                    top: '20px',
                    height: 'fit-content',
                    padding: '2rem',
                    borderRadius: '10px',
                  }}
                >
                  <div className="">
                    <p style={{ fontWeight: 'bold' }}>
                      Item #: {product.clocreProductId}
                    </p>
                  </div>

                  <div className="row align-items-center w-100">
                    {/* Current Price */}
                    <div className="col-12 col-md-auto d-flex align-items-baseline justify-content-center justify-content-md-start mb-2 mb-md-0">
                      <span
                        className="price text-g font-weight-bold"
                        style={{ fontSize: '25px' }}
                      >
                        ₹
                        {formatPrice(
                          selectedVariant
                            ? selectedVariant?.offPrice
                            : product?.offPrice
                        )}
                        /-
                      </span>
                    </div>

                    {/* Inc. GST */}
                    <div className="col-12 col-md-auto text-start text-md-left mb-2 mb-md-0">
                      <span
                        style={{
                          fontSize: '14px',
                          color: '#6c757d',
                        }}
                      >
                        (Inc. GST)
                      </span>
                    </div>

                    {/* Old Price */}
                    <div className="col-12 col-md-auto text-center text-md-left">
                      <span
                        className="oldPrice"
                        style={{
                          textDecoration: 'line-through',
                          color: '#999',
                        }}
                      >
                        ₹
                        {formatPrice(
                          selectedVariant
                            ? selectedVariant?.price
                            : product?.price
                        )}
                        /-
                      </span>
                    </div>
                  </div>

                  <div className="">
                    <div className="d-flex items-center w-100">
                      <div className="rating-outer d-flex align-items-center">
                        <div
                          className="rating-inner1"
                          style={{ width: `${(product.ratings / 5) * 100}%` }}
                        ></div>
                      </div>

                      <div className="d-flex align-items-center ml-2">
                        {user ? (
                          <button
                            onClick={handleShow}
                            id="review_btn"
                            type="button"
                            className="btn"
                            data-toggle="modal"
                            data-target="#ratingModal"
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                        ) : (
                          <div className="" style={{ width: '50%' }}></div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="pt-2 pb-3">
                    <div className="">
                      <span style={{ fontWeight: '500', color: '#2f4d2a' }}>
                        Stock :
                      </span>
                      <span style={{ color: '#2f4d2a' }}>
                        {' '}
                        {selectedVariant
                          ? selectedVariant.stock
                          : product.stock}{' '}
                      </span>
                      <br />
                      <div
                        className="d-flex align-items-center "
                        style={{
                          marginTop: '10px',
                          padding: '5px',
                        }}
                      >
                        <button
                          className="btn btn-outline-dark"
                          onClick={decreaseQty}
                        >
                          -
                        </button>

                        <input
                          type="number"
                          value={quantity}
                          onChange={e => {
                            const value = Number(e.target.value);
                            if (value >= 1) {
                              setQuantity(value);
                            }
                          }}
                          min="1"
                          className="form-control text-center mx-2"
                          style={{
                            width: '80px',
                            backgroundColor: 'transparent',
                            color: '#000',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                          }}
                          onKeyDown={e => {
                            // Prevent typing "-" or "e" (for exponential input)
                            if (['e', 'E', '+', '-'].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />

                        <button
                          className="btn btn-outline-dark"
                          onClick={increaseQty}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="pt-2 pb-2">
                    <button
                      className="btn col-12"
                      style={{
                        backgroundColor: 'none',
                        color: '#ffad63',
                        border: '2px solid #ffad63',
                        outline: 'none',
                      }}
                      // disabled={product.stock === 0}
                      onClick={handleAddToCart}
                    >
                      ADD TO CART
                    </button>
                  </div>

                  <div className="pt-2 ">
                    <p
                      style={{
                        fontStyle: 'italic',
                        fontSize: '15px',
                        color: '#2f4d2a',
                        fontWeight: 'bold',
                      }}
                    >
                      Fastest cross-border delivery
                    </p>
                  </div>
                </div>
              </div>
              <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title style={{ fontSize: '20px' }}>
                    Post Your valuable Reviews
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <ul className="stars">
                    {[1, 2, 3, 4, 5].map(star => (
                      // <li
                      //     value={star}
                      //     key={star}
                      //     onClick={() => setRating(star)}
                      //     className={`star ${star <= rating ? 'orange' : ''}`}
                      //     onMouseOver={(e) => e.target.classList.add('yellow')}
                      //     onMouseOut={(e) => e.target.classList.remove('yellow')}
                      // >
                      //     <i className="fa fa-star"></i>
                      // </li>
                      <li
                        value={star}
                        key={star}
                        onClick={() => setRating(star)}
                        style={{ fontSize: '40px' }}
                        className={`star ${star <= rating ? 'orange' : ''}`}
                        onMouseOver={e =>
                          e.currentTarget.classList.add('yellow')
                        }
                        onMouseOut={e =>
                          e.currentTarget.classList.remove('yellow')
                        }
                      >
                        <FontAwesomeIcon icon={faStar} />
                      </li>
                    ))}
                  </ul>

                  <textarea
                    onChange={e => setComment(e.target.value)}
                    name="review"
                    id="review"
                    className="form-control mt-3"
                    minLength={10}
                    maxLength={200} // Set your desired maximum length here
                  ></textarea>

                  {reviewError && (
                    <div
                      className="text-danger mt-2"
                      style={{ fontSize: '16px' }}
                    >
                      {reviewError}
                    </div>
                  )}

                  <button
                    disabled={loading}
                    onClick={reviewHandler}
                    aria-label="Close"
                    className="my-3 float-right review-btn text-dark"
                    style={{
                      backgroundColor: '#ffad63',
                      fontSize: '16px',
                      color: '#fff',
                      borderRadius: '5px',
                      padding: '7px 15px',
                    }}
                  >
                    Submit
                  </button>
                </Modal.Body>
              </Modal>
            </section>

            {/* product details 1 */}
            <section className="container-fluid">
              <h3
                className="hd"
                style={{
                  borderBottom: '2px solid #ffad63',
                  width: '170px',
                  paddingBottom: '10px',
                  marginBottom: '30px',
                  marginTop: '30px',
                }}
              >
                Product Details
              </h3>
              <div class="row">
                <div className="col-sm-6 mb-3 mb-sm-0">
                  <div
                    className="card"
                    style={{
                      height: '100%',
                      border: '2px solidrgba(140, 140, 140, 0.49)',
                    }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title"
                        style={{ borderLeft: '6px solid #ffad63' }}
                      >
                        &nbsp; Specifications
                      </h5>

                      <div
                        style={{
                          height: '100%',
                          overflowY: 'auto',
                          marginTop: '12px',
                          padding: '3px',
                          borderRadius: '4px',
                          fontSize: '13px',
                        }}
                      >
                        <table className="table">
                          <tbody>
                            {product.brand && (
                              <tr>
                                <th>Brand Name</th>
                                <td>{product.brand}</td>
                              </tr>
                            )}

                            <tr>
                              <th>CAT Code / SKU</th>
                              <td>{selectedVariant?.sku || product.sku}</td>
                            </tr>

                            {product.itemModelNum && (
                              <tr>
                                <th>Item Model / MPN</th>
                                <td>{product.itemModelNum}</td>
                              </tr>
                            )}

                            {product.upc && (
                              <tr>
                                <th>UPC</th>
                                <td>{product.upc}</td>
                              </tr>
                            )}

                            {product.condition && (
                              <tr>
                                <th>Item Condition</th>
                                <td>
                                  {product.condition === "Unboxed (Excess Inventory)"
                                    ? "Surplus (Excess Inventory)"
                                    : product.condition}
                                </td>
                              </tr>
                            )}

                            {product.productCertifications && (
                              <tr>
                                <th>Product Certifications</th>
                                <td>{product.productCertifications}</td>
                              </tr>
                            )}

                            {product.countryofOrgin && (
                              <tr>
                                <th>Country of Origin</th>
                                <td>{product.countryofOrgin}</td>
                              </tr>
                            )}

                            <tr>
                              <th>Returnable</th>
                              <td>{product.isRefundable ? 'Yes' : 'No'}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-6 mb-3 mb-sm-0">
                  <div
                    className="card"
                    style={{
                      height: '100%',
                      border: '2px solidrgba(140, 140, 140, 0.49)',
                    }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title"
                        style={{ borderLeft: '6px solid #ffad63' }}
                      >
                        &nbsp; Additional Information
                      </h5>
                      <div
                        style={{
                          height: '100%', // Adjust height as needed
                          overflowY: 'auto',
                          marginTop: '12px',
                          padding: '3px',
                          borderRadius: '4px',
                          fontSize: '13px',
                        }}
                      >
                        <table className="table">
                          <tbody>
                            {product.firstPurchaseDate && (
                              <tr>
                                <th>First Purchase Date</th>
                                <td>
                                  {new Date(
                                    product.firstPurchaseDate
                                  ).toLocaleDateString('en-IN')}
                                </td>
                              </tr>
                            )}

                            {product.useBefore && (
                              <tr>
                                <th>Use Before</th>
                                <td>
                                  {new Date(
                                    product.useBefore
                                  ).toLocaleDateString('en-IN')}
                                </td>
                              </tr>
                            )}

                            {product.productWarranty && (
                              <tr>
                                <th>Product Warranty</th>
                                <td>{product.productWarranty}</td>
                              </tr>
                            )}

                            {product.manufactureDetails && (
                              <tr>
                                <th>Manufacturer Details (OEM)</th>
                                <td>{product.manufactureDetails}</td>
                              </tr>
                            )}

                            {product.fssai && (
                              <tr>
                                <th>FSSAI</th>
                                <td>{product.fssai}</td>
                              </tr>
                            )}

                            {product.hsn && (
                              <tr>
                                <th>HSN</th>
                                <td>{product.hsn}</td>
                              </tr>
                            )}

                            {product?.manufacturer &&
                              (
                                <tr>
                                  <th>Manufacturer</th>
                                  <td>{product.manufacturer}</td>
                                </tr>
                              )}

                            {product.unit && (
                              <tr>
                                <th>Unit</th>
                                <td>{product.unit}</td>
                              </tr>
                            )}

                            {product.itemLength && (
                              <tr>
                                <th>Item Length</th>
                                <td>{product.itemLength}</td>
                              </tr>
                            )}

                            {product.itemWidth && (
                              <tr>
                                <th>Item Width</th>
                                <td>{product.itemWidth}</td>
                              </tr>
                            )}

                            {product.itemHeight && (
                              <tr>
                                <th>Item Height</th>
                                <td>{product.itemHeight}</td>
                              </tr>
                            )}

                            {product.itemWeight && (
                              <tr>
                                <th>Item Weight</th>
                                <td>{product.itemWeight}</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* product details 2 */}
            <section className="container-fluid mt-3 mb-5">
              <div class="row">
                <div class="col-sm-6">
                  <div
                    class="card"
                    style={{
                      height: '250px',
                      border: '2px solidrgba(140, 140, 140, 0.49)',
                    }}
                  >
                    <div class="card-body">
                      <h5
                        class="card-title"
                        style={{ borderLeft: '6px solid #ffad63' }}
                      >
                        &nbsp; Description
                      </h5>
                      <p class="card-text mt-3" style={{ fontSize: '17px' }}>
                        {product.description}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div
                    class="card"
                    style={{
                      height: '250px',
                      border: '2px solidrgba(140, 140, 140, 0.49)',
                    }}
                  >
                    <div class="card-body">
                      <h5
                        class="card-title"
                        style={{ borderLeft: '6px solid #ffad63' }}
                      >
                        &nbsp; Reviews
                      </h5>
                      <div
                        style={{
                          height: '80%',
                          overflowY: 'auto',
                          padding: '5px',
                          borderRadius: '4px',
                        }}
                      >
                        <p class="card-text mt-3" style={{ fontSize: '17px' }}>
                          {product.reviews && product.reviews.length > 0 && (
                            <ProductReview reviews={product.reviews} />
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* original */}
            <div className="related-products container-fluid">
              <h3
                className="hd"
                style={{
                  borderBottom: '2px solid #ffad63',
                  width: '190px',
                  paddingBottom: '10px',
                  marginBottom: '30px',
                  marginTop: '30px',
                }}
              >
                Related Products
              </h3>
              {relatedLoading ? (
                <Loader />
              ) : (
                <Swiper
                  modules={[Navigation, Pagination, Scrollbar]}
                  navigation
                  spaceBetween={20}
                  slidesPerView={isMobile ? 1 : 4}
                >
                  {relatedProducts.map(relatedProduct => (
                    <SwiperSlide key={relatedProduct._id}>
                      <Product product={relatedProduct} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
            </div>
          </>
        )}
      </>
    );
}